var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:[
    _vm.$style.radio,
    { [_vm.$style.radio_disabled]: _vm.disabled },
    { [_vm.$style.radio_error]: _vm.error }
  ]},[_c('input',{class:_vm.$style.radio__input,attrs:{"type":_vm.radio ? 'radio' : 'checkbox'},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('div',{class:[_vm.$style.radio__label, { [_vm.$style.radio__label_disabled]: _vm.disabled, [_vm.$style.radio__label_small]: _vm.isSmall }]})])
}
var staticRenderFns = []

export { render, staticRenderFns }